
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Welcome = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/dashboard");
    }, 5000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div style={{
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      background: "#f7f7f7"
    }}>
      <h1 style={{ fontSize: "24px", fontWeight: "bold", marginBottom: "1rem" }}>
        Your Wish for Grid Visibility, Granted.
      </h1>
      <img src={process.env.PUBLIC_URL + "/genie.png"} alt="Meter Genie Logo" style={{ width: "250px" }} />
    </div>
  );
};

export default Welcome;
